import { Query } from '@/_core/cqrs/types/queries';

export class UserNotificationSettingsQuery extends Query<UserNotificationSettingsQueryResult> {
    constructor() {
        super('UserNotificationSettingsQuery');
    }
}

export class NotificationProviderSettingsDto {
    Slack: boolean;
    Email: boolean;
    InApp: boolean;
}

export type UserNotificationSettingsQueryResult = UserNotificationSettings;

export class UserNotificationSettings {
    Id: string;
    AutoWatchMyCards: boolean;

    ChangeRights: NotificationProviderSettingsDto;
    FirstTimeVisitedMyBoard: NotificationProviderSettingsDto;
    InvitedMe: NotificationProviderSettingsDto;
    SomeoneCommentedOrChangedWatchedCards: NotificationProviderSettingsDto;
    SomeoneMentionedMe: NotificationProviderSettingsDto;
    SomeonePostedOnBoardDiscussions: NotificationProviderSettingsDto;

    SlackIsConnected: boolean;
}
